export default __webpack_public_path__ + "images/logo-90-konto.png";